var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m2650.2 1800h-472.32v-566.79c0-25.055-9.9531-49.082-27.668-66.797-17.715-17.715-41.742-27.668-66.797-27.668h-566.79c-25.055 0-49.082 9.9531-66.797 27.668-17.715 17.715-27.668 41.742-27.668 66.797v283.39h-472.32c-25.055 0-49.082 9.9531-66.797 27.668s-27.668 41.742-27.668 66.797v755.71-0.003906c0 25.055 9.9531 49.082 27.668 66.797 17.715 17.715 41.742 27.668 66.797 27.668h1700.4c25.055 0 49.082-9.9531 66.797-27.668 17.715-17.715 27.668-41.742 27.668-66.797v-472.32c0-25.055-9.9531-49.082-27.668-66.797-17.715-17.715-41.742-27.668-66.797-27.668zm-1605.9-94.465h377.86v566.79l-377.86 0.003907zm566.79-377.86h377.86l0.003907 944.64h-377.86zm944.64 944.64h-377.86v-283.39h377.86z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.73f1797d7a43fc5e88db8c873769faa5.svg";
export { ForwardRef as ReactComponent };